/**
 * DOTD API Client Functions
 * Frontend API client for DOTD endpoints
 */
import { kioskApi } from '../axios.js';
/**
 * Get drink colors for an instance
 * Returns pre-computed drink colors with their color families and personalities
 */
export async function getDOTDDrinkColors(instanceId) {
    const { data } = await kioskApi.get(`/dotd/instances/${instanceId}/drink-colors`);
    return data;
}
/**
 * Get drink recommendations based on outfit color
 * Returns one harmony drink and one contrast drink
 */
export async function getDOTDRecommendations(instanceId, request) {
    const { data } = await kioskApi.post(`/dotd/instances/${instanceId}/recommendations`, request);
    return data;
}
/**
 * Get DOTD instance configuration
 */
export async function getDOTDConfig(instanceId) {
    const { data } = await kioskApi.get(`/dotd/instances/${instanceId}/config`);
    return data;
}
/**
 * Update DOTD instance configuration
 */
export async function updateDOTDConfig(instanceId, config) {
    const { data } = await kioskApi.put(`/dotd/instances/${instanceId}/config`, config);
    return data;
}
/**
 * Generate drink colors using LLM (AI)
 * Triggers LLM inference for all shop drinks, falls back to average if AI fails
 */
export async function generateDOTDDrinkColors(instanceId) {
    const { data } = await kioskApi.post(`/dotd/instances/${instanceId}/generate-drink-colors`);
    return data;
}
/**
 * Calculate drink colors using weighted average (no AI)
 * Uses ingredient RGBA colors and ratios to compute average color
 */
export async function calculateDOTDDrinkColors(instanceId) {
    const { data } = await kioskApi.post(`/dotd/instances/${instanceId}/calculate-drink-colors`);
    return data;
}
/**
 * Update a specific drink's color (manual override)
 */
export async function updateDOTDDrinkColor(instanceId, recipeId, update) {
    const { data } = await kioskApi.put(`/dotd/instances/${instanceId}/drink-colors/${recipeId}`, update);
    return data;
}
/**
 * Reset a drink's color to LLM-inferred value (remove override)
 */
export async function resetDOTDDrinkColor(instanceId, recipeId) {
    const { data } = await kioskApi.delete(`/dotd/instances/${instanceId}/drink-colors/${recipeId}`);
    return data;
}
